import { render, staticRenderFns } from "./SubscriptionChangelog.vue?vue&type=template&id=099be566&scoped=true&"
import script from "./SubscriptionChangelog.vue?vue&type=script&lang=js&"
export * from "./SubscriptionChangelog.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionChangelog.vue?vue&type=style&index=0&id=099be566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099be566",
  null
  
)

export default component.exports